/* global nienhuys */
import 'leaflet';
import 'leaflet-sidebar/src/L.Control.Sidebar';
import eventBus from "../utils/eventBus";

const { L } = window;

const getLayers = (allowed = false) => {

  let data = {
    'tileLayer' : nienhuys.siteurl + '/wp-json/wp/v2/nienhuys/maps/?z={z}&x={x}&y={y}',
    'attribution' : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, under ODbL.'
  }

  if(!allowed) {
    data.tileLayer = 'https://cartodb-basemaps-1.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}{r}.png';
    data.attribution = 'Map tiles by Carto, under CC BY 3.0. Data by &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, under ODbL.'
  }

  return data;
}

const getMarkers = (map) => {
  var markerList = [];
  map.eachLayer(function(layer) {
    if(layer instanceof L.Marker) {
      markerList.push(layer);
    }
  });
  return markerList;
};

const projectMap = (allowed) => {
  const maps = document.querySelectorAll('[data-project-map]');
  if (maps.length) {

    const tileProvider = getLayers(allowed);

    maps.forEach(map => {
      const mapData = JSON.parse(map.dataset.projectMap);
      const bounds = [];

      const leafletMap = L.map(map.id, {
        scrollWheelZoom: true,
        zoomControl: false,
        maxZoom: 14,
      });

      leafletMap.touchZoom.disable();
      leafletMap.doubleClickZoom.disable();
      leafletMap.scrollWheelZoom.disable();
      leafletMap.boxZoom.disable();
      leafletMap.keyboard.disable();

      const sidebar = L.control.sidebar('marker-'+map.id, {
        closeButton: false,
        autoPan: false,
        position: 'right'
      });

      leafletMap.addControl(sidebar);

      L.control
        .zoom({
          position: 'topleft',
        })
        .addTo(leafletMap);


      // eslint-disable-next-line no-unused-vars
      mapData.forEach((item, index) => {
        if (item.coords) {
          bounds.push([item.coords.lat, item.coords.lng]);

          const MarkerIcon = L.divIcon({
            className: 'c-map__marker',
            iconSize: [24, 24],
            iconAnchor: [12, 24],
            popupAnchor: [0, 0],
            html: `<div class="c-map__marker-dot"><svg id="icon-home-marker" viewBox="0 0 55 55" fill="none">
                      <circle cx="27.5" cy="26.549" r="24" fill="currentColor"/>
                    </svg></div>`,
          });

          const marker = L.marker([item.coords.lat, item.coords.lng], {
            icon: MarkerIcon,
          }).on('click',(e) => {

            const markerID = e.sourceTarget._leaflet_id;
            const icon = e.sourceTarget._icon;
            const allMarkers = getMarkers(leafletMap);

            if(icon.classList.contains('c-map__marker--active')) {
              sidebar.hide();
              icon.classList.remove('c-map__marker--active');
            } else {
              sidebar.hide();

              allMarkers.forEach(smarker => {
                if(smarker._leaflet_id != markerID) {
                  smarker._icon.classList.remove('c-map__marker--active');
                }
              });

              icon.classList.add('c-map__marker--active');
              setTimeout(() => {
                sidebar.getContainer().querySelector('a').href = item.link;
                sidebar.getContainer().querySelector('.c-card__flagline').innerHTML = item.district;
                sidebar.getContainer().querySelector('.c-card__headline').innerHTML = item.address + ' ' + item.address_number;
                sidebar.getContainer().querySelector('.c-img__full').style.backgroundImage = 'url('+item.image+')';

                sidebar.show();

              },350);
            }

          });

          marker.addTo(leafletMap);
        }
      });

      if (bounds.length) {
        leafletMap.fitBounds(bounds);
      }

      leafletMap.attributionControl.setPrefix('');
      L.tileLayer(
        tileProvider.tileLayer,
        {
          attribution: tileProvider.attribution
        },
      ).addTo(leafletMap);
    });

  }
};
projectMap(false);
eventBus.on('nienhuys-dsgvo-osm', () => projectMap(true));



const singleMap = (allowed) => {
  const maps = document.querySelectorAll('[data-single-map]');
  if (maps.length) {

    const tileProvider = getLayers(allowed);

    maps.forEach(map => {
      const markerData = JSON.parse(map.dataset.singleMap);
      const bounds = [];

      const leafletMap = L.map(map.id, {
        scrollWheelZoom: true,
        zoomControl: false,
        maxZoom: 16,
      });

      leafletMap.touchZoom.disable();
      leafletMap.doubleClickZoom.disable();
      leafletMap.scrollWheelZoom.disable();
      leafletMap.boxZoom.disable();
      leafletMap.keyboard.disable();


      L.control
        .zoom({
          position: 'topleft',
        })
        .addTo(leafletMap);


      // eslint-disable-next-line no-unused-vars
      markerData.markers.forEach((item, index) => {
        bounds.push([item.lat, item.lng]);

        const MarkerIcon = L.divIcon({
          className: 'c-map__marker c-map__marker--active',
          iconSize: [24, 24],
          iconAnchor: [12, 24],
          popupAnchor: [0, 0],
          html: `<div class="c-map__marker-dot"><svg id="icon-home-marker" viewBox="0 0 55 55" fill="none">
                    <circle cx="27.5" cy="26.549" r="24" fill="currentColor"/>
                  </svg></div>`,
        });

        const marker = L.marker([item.lat, item.lng], {
          icon: MarkerIcon,
        })
        marker.addTo(leafletMap);
      });

      if (bounds.length) {
        leafletMap.fitBounds(bounds);
      }

      leafletMap.attributionControl.setPrefix('');
      L.tileLayer(
        tileProvider.tileLayer,
        {
          attribution: tileProvider.attribution,
        },
      ).addTo(leafletMap);
    });

  }
};
singleMap(false);
eventBus.on('nienhuys-dsgvo-osm', () => singleMap(true));
